/**
 * \u00dcber mich (About Me) content page generator
 */
import { esc } from '@/utils/escape';
import { generateSubpageShell } from './subpage-shell';

export function generateUeberMichHTML(settings: any, components: any): string {
  const page = settings.pageUeberMich || {};
  const sec = page.sections || {};
  const timeline = page.timeline || [];
  const values = page.values || [];
  const certs = (page.certifications || '').split(',').map(function(c: string) { return c.trim(); }).filter(Boolean);

  const hasImage = page.imageUrl && page.imageUrl.length > 0;

  const heroHTML = hasImage
    ? '      <section class="about-hero">\n' +
      '        <div class="about-hero__text">\n' +
      '          <h1>' + esc(page.heroTitle || '\u00dcber mich') + '</h1>\n' +
      '          <p class="content-section__text">' + esc(page.introText || '') + '</p>\n' +
      '        </div>\n' +
      '        <div class="about-hero__image">\n' +
      '          <img src="' + esc(page.imageUrl) + '" alt="' + esc(page.heroTitle || '\u00dcber mich') + '" loading="lazy">\n' +
      '        </div>\n' +
      '      </section>\n\n'
    : '      <section class="content-page__hero">\n' +
      '        <h1>' + esc(page.heroTitle || '\u00dcber mich') + '</h1>\n' +
      '        <p>' + esc(page.heroSubtitle || '') + '</p>\n' +
      '      </section>\n\n' +
      (page.introText ? '      <section class="content-section">\n' +
      '        <p class="content-section__text">' + esc(page.introText) + '</p>\n' +
      '      </section>\n\n' : '');

  const timelineHTML = sec.timeline !== false && timeline.length
    ? '      <section class="content-section">\n' +
      '        <h2 class="content-section__title">Werdegang</h2>\n' +
      '        <div class="timeline">\n' +
      timeline.map(function(item: any) {
        return '          <div class="timeline__item">\n' +
          '            <div class="timeline__year">' + esc(item.year) + '</div>\n' +
          '            <div class="timeline__content">\n' +
          '              <h3>' + esc(item.title) + '</h3>\n' +
          '              <p>' + esc(item.text) + '</p>\n' +
          '            </div>\n' +
          '          </div>';
      }).join('\n') + '\n' +
      '        </div>\n' +
      '      </section>\n\n'
    : '';

  const valuesHTML = sec.values !== false && values.length
    ? '      <section class="content-section">\n' +
      '        <h2 class="content-section__title">Unsere Werte</h2>\n' +
      '        <div class="values-grid">\n' +
      values.map(function(v: any) {
        return '          <div class="value-card">\n' +
          '            <h3>' + esc(v.title) + '</h3>\n' +
          '            <p>' + esc(v.text) + '</p>\n' +
          '          </div>';
      }).join('\n') + '\n' +
      '        </div>\n' +
      '      </section>\n\n'
    : '';

  const certsHTML = sec.certifications !== false && certs.length
    ? '      <section class="content-section">\n' +
      '        <h2 class="content-section__title">Zertifikate & Mitgliedschaften</h2>\n' +
      '        <div class="certifications">\n' +
      certs.map(function(c: string) {
        return '          <span class="certification-badge">' + esc(c) + '</span>';
      }).join('\n') + '\n' +
      '        </div>\n' +
      '      </section>\n'
    : '';

  const bodyContent = heroHTML + timelineHTML + valuesHTML + certsHTML;

  return generateSubpageShell(settings, components, {
    title: page.heroTitle || '\u00dcber mich',
    metaDesc: page.heroSubtitle || '',
    bodyContent: bodyContent,
  });
}
